import { apiClient } from './client';
import type { Feedback, FeedbackInput } from '@/types';

export const feedbackApi = {
  submit: async (feedback: FeedbackInput): Promise<Feedback> => {
    const { data } = await apiClient.post<Feedback>('/feedback', feedback);
    return data;
  },
};
